import * as React from "react"
import "../styles/styles.sass"
import SidebarNavigation from "../components/sidebarNavigation"
import TitleBar from "../components/titleBar"
import ListRow from "../components/list"

// Markup
const ExperimentsPage = () => {
  return (
    <main className="lighthouseView experimentsView">
      <title>Experiments</title>
      <SidebarNavigation />

      <div className="viewWindow">
        <TitleBar title="Experiments" actions=""/>
        <div className="viewContent">
          <div className="list">
            <div className="listSection">
              <div className="listGroup">
                <ListRow
                  link=""
                  icon=""
                  title="Experiment 1"
                  detail="trailing"
                  detailText="Placeholder"
                  accessory="none"
                />

                <ListRow
                  link=""
                  icon=""
                  title="Experiment 2"
                  detail="trailing"
                  detailText="Placeholder"
                  accessory="none"
                />

                <ListRow
                  link=""
                  icon=""
                  title="Experiment 3"
                  detail="trailing"
                  detailText="Placeholder"
                  accessory="none"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default ExperimentsPage
